export const STEPS = {
  START: 'start',
  BASIC_INFO: 'basic-info',
  OTP_VALIDATION: 'otp-validation',
  EXISTS_OTP_VALIDATION: 'exists-otp-validation',
  PASSWORD: 'password',
  SUCCESS_BASIC: 'success-basic',
  SUCCESS_BASIC_LINKED: 'success-basic-linked',
  IDENTITY_VALIDATION: 'identity-validation',
  IDENTITY_RESUME: 'identity-resume',
  ADDRESS: 'address',
  SUCCESS_COMPLETE: 'success-complete',
};

export const SUCCESS_TYPES = {
  BASIC: 'basic',
  BASIC_LINKED: 'basic-linked',
  COMPLETE: 'complete',
};

export const CLIENT_EXISTS_TYPES = {
  CLIENT_ID: 'CLIENT_ID',
  INE: 'INE',
};

export const GENDERS = {
  MALE: 'MALE',
  FEMALE: 'FEMALE',
};

export const ID_MISSION_VARS = {
  APPROVED: 'Approved',
  OK: 'OK',
  CUSTOMER_ONBOARDED: 'Customer Onboarded',
  DUPLICATE_CUSTOMER: 'Duplicate Customer',
};

/** Tipo de documento ID Mission: VID (INE/IFE) usa M/H; PP (pasaporte) usa M/F */
export const ID_TYPE = {
  VID: 'VID',
  PP: 'PP',
};

export const COUNTRIES = {
  AD: 'Andorra',
  AR: 'Argentina',
  BO: 'Bolivia',
  CL: 'Chile',
  CO: 'Colombia',
  CR: 'Costa Rica',
  CU: 'Cuba',
  EC: 'Ecuador',
  SV: 'El Salvador',
  ES: 'España',
  GQ: 'Guinea Ecuatorial',
  GT: 'Guatemala',
  HN: 'Honduras',
  MX: 'México',
  NI: 'Nicaragua',
  DO: 'República Dominicana',
  PA: 'Panamá',
  PE: 'Perú',
  PY: 'Paraguay',
  UY: 'Uruguay',
  VE: 'Venezuela',
};
